export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-play-circle-line',
      title: '퍼포먼스 마케팅 영상',
      description: '광고 성과를 극대화하는 영상 및 이미지 소재를 제작합니다. 각 플랫폼에 최적화된 크리에이티브로 전환율을 높입니다.',
      features: ['광고 영상 소재', '이미지 크리에이티브', '플랫폼별 최적화']
    },
    {
      icon: 'ri-film-line',
      title: '트레일러 영상',
      description: '게임의 매력을 극대화하는 트레일러와 브랜딩 영상을 제작합니다. 게임의 정체성을 명확하게 전달하는 영상 콘텐츠를 만듭니다.',
      features: ['게임 트레일러', '브랜딩 영상', '스토리텔링 콘텐츠']
    },
    {
      icon: 'ri-video-line',
      title: '소셜 채널 바이럴 영상',
      description: '유튜브 쇼츠 등 소셜 채널에서 자연스럽게 퍼져나가는 바이럴 콘텐츠를 제작합니다. 게임 추천 영상으로 입소문을 만듭니다.',
      features: ['유튜브 쇼츠', '게임 추천 영상', '바이럴 콘텐츠']
    }
  ];

  return (
    <section id="services" className="relative py-32 overflow-hidden">
      {/* Dark background */}
      <div className="absolute inset-0 bg-[#1a1a1a]"></div>
      
      {/* Atmospheric lighting */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#F6B766]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-[#F4A259]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10 container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#F6B766]/50"></div>
            <span className="mx-4 text-[#F6B766]/70 text-sm tracking-[0.3em] uppercase">Services</span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#F6B766]/50"></div>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-light text-white mb-6">
            우리가 <span className="text-[#F6B766]">만드는 것</span>
          </h2>
          <p className="text-xl text-white/60 max-w-3xl mx-auto font-light leading-relaxed">
            전당포 골목의 숨은 고수처럼, 우리는 당신의 게임을 전세계에 퍼뜨립니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-2xl p-10 hover:border-[#F6B766]/30 transition-all duration-500 hover:shadow-2xl hover:shadow-[#F6B766]/5"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#F6B766]/20 to-[#F4A259]/10 rounded-xl mb-8 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-[#F6B766] text-3xl`}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-light text-white mb-4 group-hover:text-[#F6B766] transition-colors">
                {service.title}
              </h3>
              
              <p className="text-white/60 mb-8 leading-relaxed font-light">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-white/50 text-sm">
                    <div className="w-1.5 h-1.5 bg-[#F6B766] rounded-full mr-3"></div>
                    {feature}
                  </li>
                ))}
              </ul>

              {/* Hover glow effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#F6B766]/0 to-[#F4A259]/0 group-hover:from-[#F6B766]/5 group-hover:to-[#F4A259]/5 rounded-2xl transition-all duration-500 pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
